// extracted by mini-css-extract-plugin
module.exports =  {"root":"root_GaFyVHG0","container":"container_AFIjy1kM","inner":"inner_jP4wYCxH","textContainer":"textContainer_RQiwo4RP","itemTitle":"itemTitle_QOEPLX8q"};